// src/env.json
var env_default = {
  env: "production",
  mossKey: "UnRxR1lhczNKbmkyMlRDZTQ3WkdwQThrRnVSM1FNaDg=",
  appProtocol: "mavishub",
  sentryDsn: "https://84d4905d19e14e1fbfae5a604c644427@o998185.ingest.sentry.io/4504728040570880",
  serverGateway: "https://hub-api.skymavis.com",
  captchaEndpoint: "https://x.skymavis.com",
  captchaKey: "5a0eb357-db13-4911-a810-c1914c17bc6f",
  accountService: "https://accounts.skymavis.com",
  playGameDomain: "https://play.axieinfinity.com",
  uiEndpoint: "https://hub.skymavis.com",
  overlayEndpoint: "https://hub.skymavis.com/overlay",
  idEndpoint: "https://waypoint.roninchain.com",
  idClientId: "b84fe6f2-9fd5-46b3-803b-1a5a81b467e8",
  idRedirect: "https://hub.skymavis.com/id/login/redirect",
  chainId: 2020,
  storeGateway: "https://mavis-store-api.skymavis.com",
  storeDomain: "https://store.skymavis.com"
};

// src/index.ts
var globalConfig = {
  marketplaceEndpoint: "https://app.axieinfinity.com/marketplace",
  marketplaceAssetPath: {
    "0x32950db2a7164ae833121501c797d79e7b79d74c": "axies",
    "0x8c811e3c958e190f5ec15fb376533a3398620500": "lands",
    "0xa96660f0e4a3e9bc7388925d245a6d4d79e21259": "items",
    "0xc25970724f032af21d801978c73653c440cf787c": "runes",
    "0x814a9c959a3ef6ca44b5e2349e3bba9845393947": "charms"
  },
  explorerEndpoint: "https://app.roninchain.com"
};
var config = env_default;
var src_default = config;
export {
  config,
  src_default as default,
  globalConfig
};
//# sourceMappingURL=index.mjs.map